var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name !== 'trailer' && _vm.credits)?_c('div',{staticClass:"credits",domProps:{"innerHTML":_vm._s(_vm.credits)}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d481ec34","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/credits.vue
// module id = 74
// module chunks = 1